import { HERO_VIDEO_POSTER } from "../constants";

// Illustrative team multiview. Labels are stream chrome and stay untranslated.
const CARS = [
  { car: "#49 KIM", gap: "0.4 s", lap: "LAP 12 · 1:52.31", position: "center 35%", filter: "" },
  { car: "#7 PARK", gap: "0.6 s", lap: "LAP 12 · 1:52.88", position: "70% center", filter: "saturate(.85) hue-rotate(-12deg)" },
  { car: "#21 LEE", gap: "0.5 s", lap: "LAP 11 · 1:53.40", position: "30% 40%", filter: "saturate(.9) brightness(.9)" },
  { car: "#3 CHOI", gap: "0.7 s", lap: "LAP 11 · 1:54.02", position: "55% 70%", filter: "saturate(.8) hue-rotate(14deg) brightness(.95)" },
];

export default function MultiviewMock() {
  return (
    <div
      className="grid grid-cols-2 gap-[3px] overflow-hidden rounded-2xl bg-black"
      aria-hidden="true"
    >
      {CARS.map((c) => (
        <div
          key={c.car}
          className="relative aspect-video overflow-hidden bg-black bg-cover text-white"
          style={{
            backgroundImage: `url(${HERO_VIDEO_POSTER})`,
            backgroundPosition: c.position,
            filter: c.filter || undefined,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60" />
          <div className="absolute inset-0 flex flex-col justify-between p-2.5 font-mono text-[10px] tracking-[0.04em]">
            <div className="flex items-center justify-between">
              <span className="text-[11px] font-semibold">{c.car}</span>
              <span className="inline-flex items-center gap-1 rounded bg-red-500/90 px-1.5 py-0.5 font-semibold">
                <span className="h-1 w-1 rounded-full bg-white" />
                {c.gap}
              </span>
            </div>
            <span className="text-white/85">{c.lap}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
